import React, {useMemo} from 'react';
import {Route, Routes} from "react-router-dom";
import type {HotspotExplorerProps} from "./types";
import {AllHotspotsView} from "./all-hotspots";
import {CountryHotspotsView} from "./country";
import {CountyHotspotsView} from "./county";
import {HotspotDetailView} from "./hotspot-detail";
import {StateHotspotsView} from "./state";

export default function HotspotExplorer(props: HotspotExplorerProps) {
    const routeTree = useMemo(() => {
        return (
            <Routes>
                <Route path="/hotspot-explorer" element={<AllHotspotsView {...props} />} />
                <Route path="/hotspot-explorer/country/:countryCode" element={<CountryHotspotsView {...props} />} />
                <Route path="/hotspot-explorer/country/:countryCode/state/:stateProvince" element={<StateHotspotsView {...props} />} />
                <Route path="/hotspot-explorer/country/:countryCode/state/:stateProvince/county/:county" element={<CountyHotspotsView {...props} />} />
                <Route path="/hotspot-explorer/hotspot/:locationId" element={<HotspotDetailView {...props} />} />
            </Routes>
        );
    }, [props]);

    return routeTree;
}
